
import Plyr from 'plyr';


// Featured video
jQuery(function($){

	// Change "{}" to your options:
	// https://github.com/sampotts/plyr/#options
	const player = new Plyr('#player', {
		title: '',
	});

	// Expose player so it can be used from the console
	window.player = player;

	// Play video when overlay is clicked on
	$(".featured-video__overlay").click(function() { 
		console.log('111');
		player.play(); 
	});

	// When playing hide overlay and show plyr
	player.on('play', (event) => {
		$(".block-featured-video").addClass('js-video-playing');
	});

	// When pause hide plyr and show overlay
	player.on('pause', (event) => {
		$(".block-featured-video").removeClass('js-video-playing');
	});

});


// // Featured video
// jQuery(function($){
// 
// 	var playing = false;
// 
// 	//Video block clicked - Firing every time
// 	$(".section-featured-video .block-featured-video").click(function() { 
// 
// 		var elem = $(this);
// 		var videoElem = $(this).find("video");
// 		var mediaVideo = videoElem.get(0);
// 
// 		if (playing == false) {
// 			// setTimeout(function() {
// 				mediaVideo.play(); //Play the video
// 			// }, 1);
// 		}
// 
// 	});
// 
// 
// 	//Video block clicked - Firing only once
// 	$(".section-featured-video .block-featured-video").one( "click", function() {
// 
// 		var elem = $(this);
// 		var videoElem = $(this).find("video");
// 		var mediaVideo = videoElem.get(0);
// 
// 		mediaVideo.addEventListener('play', (event) => {
// 			console.log('Video played');
// 			elem.addClass('js-video-active'); //Add active class (to hide overlay)
// 			videoElem.attr('controls',''); //Show controls
// 			playing = true;
// 		});
// 
// 		mediaVideo.addEventListener('pause', (event) => {
// 			console.log('Video paused');
// 			elem.removeClass('js-video-active'); //Remove active class (to show overlay)
// 			// videoElem.removeAttr('controls',''); //Hide controls (cause issues with scrubbing)
// 			playing = false; 
// 		});
// 
// 
// 	});
// 
// 
// });


